import React from 'react';
import { Box, Typography } from '@mui/material';
import { useStyles } from './../../styles';
import PropTypes from 'prop-types';
import { enumToColumnNames } from '../../../../constants/constant';

function CustomTableMetricOption(props) {
	let { name, parentCallback, searchText, options, shortName } = props;

	const classes = useStyles();

	const handleCheck = (event) => {
		parentCallback(event.target.id, !checked);
		setChecked(!checked);
		event.preventDefault();
	};

	const isActive = (item) => {
		return options?.includes(item);
	};
	const [checked, setChecked] = React.useState(isActive(shortName));

	const highlightText = (boldText, sourceText) => {
		if (!sourceText) {
			return '';
		}
		const index = sourceText.indexOf(boldText);

		if (index === -1) {
			return sourceText;
		}
		const lastIndex = index + boldText.length;

		return (
			<>
				{`${sourceText.slice(0, index)}`}
				<b>{sourceText.slice(index, lastIndex)}</b>
				{sourceText.slice(lastIndex)}
			</>
		);
	};

	const Checkbox = ({ label, value, onChange, shortName }) => {
		return (
			<label>
				<input
					id={label}
					data-test-id={label + '-checkbox'}
					data-test-shortName={shortName}
					className={classes.table_checkbox}
					type="checkbox"
					checked={value}
					onChange={onChange}
				/>
				<Typography className={classes.table_checkboxText}>
					{ highlightText(searchText, enumToColumnNames[label]) }
				</Typography>
			</label>
		);
	};

	Checkbox.propTypes = {
		label: PropTypes.string.isRequired,
		value: PropTypes.bool,
		onChange: PropTypes.func.isRequired,
		shortName: PropTypes.string.isRequired,
	};

	return (
		<Box className={classes.table_metricOptions}>
			<Box>
				{/* Checkbox */}
				<Checkbox
					id={name}
					label={shortName}
					value={checked}
					onChange={handleCheck}
					shortName={shortName}
				/>
			</Box>
		</Box>
	);
}

CustomTableMetricOption.propTypes = {
	name: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	isChecked: PropTypes.bool,
	parentCallback: PropTypes.func.isRequired,
	searchText: PropTypes.string,
	shortName: PropTypes.string.isRequired,
};

export default CustomTableMetricOption;
